import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { SelectList } from "@common/selectList";
import { ArrowIcon } from "@common/assets/arrowIcon";
import { SortOptions } from "../../types";
import { Props } from "./type";
import styles from "./styles.scss";

function Sort({ sort, setSort }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.sortDropdown}>
      <div className={styles.title}>
        <p>{t("zonePage.reportsPage.sortOptions.title")}</p>
      </div>
      <SelectList rootClassName={styles.root} listClassName={styles.listRoot}>
        {({ isOpen, select }) => ({
          input: (
            <div
              className={classNames(styles.input, {
                [styles.opened]: isOpen,
              })}
            >
              <p>{t(sort)}</p>
              <ArrowIcon className={styles.icon} />
            </div>
          ),
          list: (
            <div className={styles.list}>
              {Object.values(SortOptions).map((option, key) => (
                <div
                  key={key}
                  className={classNames(styles.option, {
                    [styles.selected]: option === sort,
                  })}
                  onClick={() => select(setSort(option))}
                >
                  <p>{t(option)}</p>
                </div>
              ))}
            </div>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { Sort };
